/* KAPSEL BDK1 (2026-10-01): snabbkop fran delkortet (snippets/kapsel-part-card) och kassan i Bygg din Kapsel.
   Samma vag som temats egen kopknapp (assets/product-form.js): CartLinesUpdateEvent fran @shopify/events,
   sa att antalet i sidhuvudet och varukorgslådan uppdateras, sedan oppnas lådan.
   Saknas lådan eller modulen gar kunden till varukorgen i stallet. */
(function () {
  if (window.__kapselQuickAdd) return;
  window.__kapselQuickAdd = true;

  function routes() { return window.kapselRoutes || { add: '/cart/add.js', cart: '/cart' }; }

  function openDrawer() {
    var d = document.querySelector('theme-drawer#cart-drawer');
    if (d && typeof d.open === 'function') { if (!d.isOpen) d.open(); return true; }
    return false;
  }

  /* 6 okt avstamning (bdk2-v40/avstamning.md): korgattributen och Klaviyo-profilen.
     kapsel_kalla raknas ur radernas _kapsel_kalla i hela korgen (anpassa, snabbkop eller anpassa,snabbkop).
     Finns ingen Anpassa-rad kvar tas kapsel_urval, kapsel_personer, kapsel_farg och kapsel_utm bort.
     Det gamla attributet 'Bygg din Kapsel' tas bort. Andras inget gors inget anrop. */
  var KATTR = ['kapsel_urval', 'kapsel_personer', 'kapsel_farg', 'kapsel_utm'];
  function korgAttr(cart) {
    var a = cart.attributes || {}, src = {}, up = {}, n = 0;
    (cart.items || []).forEach(function (i) { var k = i.properties && i.properties._kapsel_kalla; if (k) src[k] = 1; });
    var kalla = ['anpassa', 'snabbkop'].filter(function (k) { return src[k]; }).join(',');
    if (kalla && a.kapsel_kalla !== kalla) { up.kapsel_kalla = kalla; n++; }
    if (!src.anpassa) KATTR.forEach(function (k) { if (a[k]) { up[k] = ''; n++; } });
    if (a['Bygg din Kapsel'] !== undefined) { up['Bygg din Kapsel'] = ''; n++; }
    return n ? up : null;
  }
  function korgProfil(cart) {
    var m = {}, ord = [];
    (cart.items || []).forEach(function (i) { if (!m[i.variant_id]) { m[i.variant_id] = 0; ord.push(i.variant_id); } m[i.variant_id] += i.quantity; });
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return { kapsel_korg_lank: ord.length ? root + 'cart/' + ord.map(function (v) { return v + ':' + m[v]; }).join(',') : '', kapsel_korg_rader: (cart.items || []).length };
  }

  /* Lagger rader i varukorgen och oppnar lådan. items: [{ id, quantity, properties }], el: elementet som skickar
     handelsen, extra: mer till /cart/add.js (t.ex. attributes), profil: Klaviyo-profilegenskaper fran Anpassa.
     Ger true nar det gick. Korgen efterat ligger i window.kapselSenasteKorg. */
  /* 14 okt (systemarket): opts.noOpen lagger i korgen utan att oppna ladan, sa att den inte hamnar bakom ett ark.
     window.kapselOpenCart oppnar ladan nar kunden sjalv vill se korgen. */
  async function cartAdd(items, el, extra, profil, opts) {
    var R = routes(), Ev = null, deferred = null;
    try { Ev = (await import('@shopify/events')).CartLinesUpdateEvent; } catch (e) { Ev = null; }
    if (Ev) {
      deferred = Ev.createPromise();
      (el || document).dispatchEvent(new Ev({ action: 'add', context: 'product', lines: items.map(function (i) { return { merchandiseId: String(i.id), quantity: i.quantity }; }), promise: deferred.promise }));
    }
    try {
      var body = Object.assign({ items: items, sections: 'cart-drawer-section' }, extra || {});
      var res = await fetch(R.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
      var failed = !!res.status, cart = null;
      try { cart = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); } catch (e) { cart = null; }
      if (!failed && cart) {
        var up = korgAttr(cart);
        if (up) { try { cart = await fetch(R.cart + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: up }) }).then(function (r) { return r.json(); }); } catch (e) {} }
        window.kapselSenasteKorg = cart;
        if (window.kapselProfil) window.kapselProfil(Object.assign(korgProfil(cart), profil || {}));
      }
      if (deferred) {
        if (!cart) throw new Error('cart');
        deferred.resolve({ cart: Ev.createCartFromAjaxResponse(cart), detail: { items: cart.items, itemCount: items.length, sections: failed ? undefined : res.sections, didError: failed, source: 'kapsel' } });
      }
      if (failed) return false;
    } catch (e) {
      if (deferred) deferred.reject(e);
      return false;
    }
    if (opts && opts.noOpen) return true;
    if (!openDrawer()) window.location.href = R.cart;
    return true;
  }
  window.kapselCartAdd = cartAdd;
  window.kapselOpenCart = function () {
    if (window.SectionStoreCart && typeof window.SectionStoreCart.open === 'function') { window.SectionStoreCart.open(); return; }
    if (!openDrawer()) window.location.href = routes().cart;
  };

  /* BDK2 6 okt sparning: snabbkopet bar sin kalla pa raden (SPEC.md i bdk2-v40/sparning). */
  function add(id, btn) { return cartAdd([{ id: Number(id), quantity: 1, properties: { _kapsel_kalla: 'snabbkop' } }], btn); }

  document.addEventListener('click', async function (e) {
    var b = e.target.closest('button[data-kqa]');
    if (!b || b.classList.contains('is-busy')) return;
    e.preventDefault();
    var t = b.querySelector('.kpc__t');
    b.classList.remove('is-done', 'is-err');
    b.classList.add('is-busy');
    var ok = await add(b.getAttribute('data-kqa'), b);
    if (ok && window.kapselSpar) {
      var card = b.closest('.kpc'), nm = card && card.querySelector('.kpc__n'), sec = b.closest('[id^="shopify-section-"]');
      window.kapselSpar('kapsel_snabbkop', { variant_id: Number(b.getAttribute('data-kqa')), namn: nm ? nm.textContent.trim() : '', pris: card ? (+card.getAttribute('data-price') || 0) / 100 : null, plats: sec ? sec.id.replace('shopify-section-', '') : '' });
    }
    b.classList.remove('is-busy');
    b.classList.add(ok ? 'is-done' : 'is-err');
    if (t) t.textContent = b.getAttribute(ok ? 'data-t-done' : 'data-t-err');
    setTimeout(function () { b.classList.remove('is-done', 'is-err'); if (t) t.textContent = b.getAttribute('data-t-add'); }, 2400);
  });

  /* BDK2 (5 okt): prickarna under delkortets bilder foljer svepet (snippets/kapsel-part-card). */
  document.addEventListener('scroll', function (e) {
    var tr = e.target;
    if (!tr || !tr.hasAttribute || !tr.hasAttribute('data-kpc-track')) return;
    var dots = tr.parentNode.querySelectorAll('.kpc__dot');
    if (!dots.length || !tr.clientWidth) return;
    var i = Math.round(tr.scrollLeft / tr.clientWidth);
    for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
  }, { capture: true, passive: true });
})();

(function () {
  if (window.kapselCardChoicesBound) return;
  window.kapselCardChoicesBound = true;
  function initialiseCardImages() {
    document.querySelectorAll('[data-kpc-variants]').forEach(function (source, index) {
      source.closest('.kpc').querySelectorAll('[data-kpc-option]').forEach(function(input){ input.name = 'kpc-' + index + '-' + input.dataset.kpcOption; });
      var data; try { data = JSON.parse(source.textContent); } catch (_) { return; }
      var variant = data.variants.find(function (v) { return v.options.every(function (value, i) { return data.initial[i] === value; }); });
      var image = source.closest('.kpc').querySelector('.kpc__img');
      if (!variant) return;
      var card = source.closest('.kpc');
      var url = new URL(data.url, window.location.origin); url.searchParams.set('variant', variant.id);
      card.querySelectorAll('a.kpc__plate, a.kpc__info, a.kpc__add--link').forEach(function(a) { a.href = url.pathname + url.search; });
      var price = card.querySelector('.kpc__m'); if (price) price.textContent = variant.price;
      var summary = card.querySelector('[data-kpc-summary]'); if (summary) summary.textContent = variant.label;
      if (image && variant.image) { image.removeAttribute('srcset'); image.src = variant.image; image.alt = variant.alt; }
      var image2 = source.closest('.kpc').querySelectorAll('.kpc__img')[1];
      if (image2 && variant.image2) { image2.removeAttribute('srcset'); image2.src = variant.image2; }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseCardImages, {once:true});
  else initialiseCardImages();
  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-kpc-option]');
    if (!select) return;
    var card = select.closest('.kpc'), source = card.querySelector('[data-kpc-variants]');
    if (!source) return;
    var data;
    try { data = JSON.parse(source.textContent); } catch (_) { return; }
    var choices = data.initial.slice();
    card.querySelectorAll('[data-kpc-option]').forEach(function (el) { if (el.checked) choices[Number(el.dataset.kpcOption)] = el.value; });
    var variant = data.variants.find(function (v) { return v.options.every(function (value, i) { return choices[i] === value; }); });
    var links = card.querySelectorAll('a.kpc__plate, a.kpc__info, a.kpc__add--link');
    var status = card.querySelector('[data-kpc-status]');
    if (!variant) {
      links.forEach(function (a) { a.setAttribute('aria-disabled','true'); a.removeAttribute('href'); });
      if (status) status.hidden = false;
      return;
    }
    var url = new URL(data.url, window.location.origin);
    url.searchParams.set('variant', variant.id);
    links.forEach(function (a) { a.href = url.pathname + url.search; a.removeAttribute('aria-disabled'); });
    if (status) status.hidden = variant.available;
    var price = card.querySelector('.kpc__m');
    if (price) price.textContent = variant.price;
    var summary = card.querySelector('[data-kpc-summary]'); if (summary) summary.textContent = variant.label;
    var image = card.querySelector('.kpc__img');
    if (image && variant.image) {
      image.removeAttribute('srcset'); image.src = variant.image; image.alt = variant.alt;
      var image2 = card.querySelectorAll('.kpc__img')[1];
      if (image2 && variant.image2) { image2.removeAttribute('srcset'); image2.src = variant.image2; }
      card.classList.add('kpc--variant');
      var track = card.querySelector('[data-kpc-track]');
      if (track) track.scrollLeft = 0;
    }
  });
})();

(function(){
  if(window.kapselCardDialogsBound)return;window.kapselCardDialogsBound=true;
  document.addEventListener('click',function(e){
    var open=e.target.closest('[data-kpc-open]'); if(open){open.closest('.kpc').querySelector('dialog').showModal();return;}
    var close=e.target.closest('[data-kpc-close]');if(close){close.closest('dialog').close();return;}
    if(e.target.matches('dialog.kpc__dialog')){var r=e.target.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)e.target.close();}
  });
})();
